import {useEffect, useState} from 'react'

import type {Image} from './content-preview-types'
import styles from './ImagePreview.module.css'

export function ImagePreview({image}: {image: Image}) {
  const [failedUrl, setFailedUrl] = useState<string>()
  const [objectUrl, setObjectUrl] = useState<{blob: Blob; url: string}>()
  const blob = image.blob
  useEffect(() => {
    if (!blob) return
    const url = URL.createObjectURL(blob)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- The URL lifetime belongs to this mounted preview.
    setObjectUrl({blob, url})
    return () => URL.revokeObjectURL(url)
  }, [blob])
  const url = blob ? (objectUrl?.blob === blob ? objectUrl.url : undefined) : image.url
  return (
    <div className={styles.container}>
      {!url ? (
        <p role="status">Loading image…</p>
      ) : failedUrl === url ? (
        <p role="status">Unable to load {image.name}. The image may no longer exist or you may not have access.</p>
      ) : (
        <img className={styles.imageElement} src={url} alt={image.altText} onError={() => setFailedUrl(url)} />
      )}
    </div>
  )
}
